export default __webpack_public_path__ + "img/artificial-intelligence.7aff3a87.png";